import { c as _c } from "react/compiler-runtime";
import { cn } from '@/frontend/utils';
type DockerProps = React.SVGProps<SVGSVGElement> & {
  size?: string | number;
};
export function Docker(t0) {
  const $ = _c(11);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const sizeClass = size ? `size-${size}` : "size-12";
  let t1;
  if ($[4] !== className || $[5] !== sizeClass) {
    t1 = cn(sizeClass, className);
    $[4] = className;
    $[5] = sizeClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fill="#1d63ed" strokeWidth="0" d="M743.96 245.25c-18.54-12.48-67.26-17.81-102.68-8.27-1.91-35.28-20.1-65.01-53.38-90.95l-12.32-8.27-8.21 12.4c-16.14 24.5-22.94 57.14-20.53 86.81 1.9 18.28 8.26 38.83 20.53 53.74-46.1 26.74-88.59 20.67-276.77 20.67H.06c-.85 42.49 5.98 124.23 57.96 190.77 5.74 7.35 12.04 14.46 18.87 21.31 42.26 42.32 106.11 73.35 201.59 73.44 145.66.13 270.46-78.6 346.37-268.97 24.98.41 90.92 4.48 123.19-57.88.79-1.05 8.21-16.54 8.21-16.54l-12.3-8.27Zm-554.29-38.86h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm-422.2 0H2.42v81.7h81.7zM189.67 103.2h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm0-103.2h-81.7v81.7h81.7z" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1) {
    t3 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 756.26 596.9" className={t1} {...props}>{t2}</svg>;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}